import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../../components/Loading";
import { fetchContentByKey, updateContentById } from "../../../services/contents";
import DropDownMenu from '../../../components/DropdownMenu'
import RemoveSvg from '../../../svgs/RemoveSvg'
import FileDropzone from '../../../components/FileDropzone'
import { uploadPhoto } from '../../../services/documents';
import RefreshButton from "../../../svgs/RefreshButton";
import SaveButton from "../../../svgs/SaveButton";

const CardTypeNameDict1 = {
    'card1': '圖片卡片1',
    'card2': '文字和照片',
    'card3': '照片',
}
const CardTypeNameDict2 = {
    '圖片卡片1': 'card1',
    '文字和照片': 'card2',
    '照片': 'card3',
}
const CARD_TYPES = ['文字和照片', '照片']

const CONTENT_CARD_TYPES  = ['文字,照片和地點', '照片','照片縮圖和文字','照片輪播']
const ContentCardTypeNameDict1 = {
    'card-01': '文字,照片和地點',
    'card-02': '照片',
    'card-03': '照片縮圖和文字',
    'card-04': '照片輪播',
}
const ContentCardTypeNameDict2 = {
    '文字,照片和地點': 'card-01',
    '照片': 'card-02',
    '照片縮圖和文字': 'card-03',
    '照片輪播': 'card-04',
}
const ContentImageSizesDict={
    'card-01': {width: 600, height: 300},
    'card-02':  {width: 398, height: 166},
    'card-03':  {width: 398, height: 398},
    'card-04':  {width: 805, height: 237},
}

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState({})

    async function fetchData() {
        const result = await fetchContentByKey('homepage_content')
        if (result?.result?.[0]) setData(result?.result?.[0] || {});
    }
    async function refresh() {
        setIsloading(true)
        await fetchData()
        setIsloading(false)
    }
    useEffect(() => {
        if (!props.token.isLogin) return
        refresh()
    }, [props.token])

    const onDropImageFileForArray = (item, index, arrayField, imageField, uploadFolder, filename) => async (files) => {
        if (files.length > 1) { alert(`僅允許上傳一個檔案。`); return }
        const file = files[0]
        if (!['image/png', 'image/jpeg'].includes(file.type)) { alert(`文件類型不允許: ${file.type}`); return }
        if (file.size > 1024 * 1024 * 5) { alert(`檔案大小必須在 5 MB 以內`); return }
        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));
        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, uploadFolder, filename);
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                let updateData = {
                    [arrayField]: data?.[arrayField]?.map((item, i) => {
                        if (i === index) { item[imageField] = filepath }
                        return item
                    })
                };
                setData({ ...data, ...updateData })
            } else {
                alert('上傳失敗')
            }
        }
        setIsloading(false);
    }
    const onDropImageFileForArrayCard04 = (item, index,dataItem,dataIndex, arrayField, imageField, uploadFolder, filename) => async (files) => {
        if (files.length > 1) { alert(`僅允許上傳一個檔案。`); return }
        const file = files[0]
        if (!['image/png', 'image/jpeg'].includes(file.type)) { alert(`文件類型不允許: ${file.type}`); return }
        if (file.size > 1024 * 1024 * 5) { alert(`檔案大小必須在 5 MB 以內`); return }
        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));
        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, uploadFolder, filename);
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                let updateData = {
                    [arrayField]: data?.[arrayField]?.map((item, i) => {
                        if (i === index) { 
                            item.data[dataIndex][imageField]= filepath
                        }
                        return item
                    })
                };
                setData({ ...data, ...updateData })
            } else {
                alert('上傳失敗')
            }
        }
        setIsloading(false);
    }
    const onDropImageFile = (field, imageField, uploadFolder, filename) => async (files) => {
        if (files.length > 1) { alert(`僅允許上傳一個檔案。`); return }
        const file = files[0]
        if (!['image/png', 'image/jpeg'].includes(file.type)) { alert(`文件類型不允許: ${file.type}`); return }
        if (file.size > 1024 * 1024 * 5) { alert(`檔案大小必須在 5 MB 以內`); return }
        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));
        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, uploadFolder, filename);
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                let updateData = {
                    [field]: { ...(data?.[field] || {}), [imageField]: filepath }
                };
                setData({ ...data, ...updateData })
            } else {
                alert('上傳失敗')
            }
        }
        setIsloading(false);
    }


    async function handleSave() {
        setIsloading(true)
        const newData = {
            recommendations: data?.recommendations,
            advertisement_card_1: data?.advertisement_card_1,
            button_1: data?.button_1,
            contents_recommnedations: data?.contents_recommnedations,
            contents_promotions: data?.contents_promotions,
            contents_events: data?.contents_events,
            contents_services: data?.contents_services,
            contents_projects: data?.contents_projects,
        }
        let res = await updateContentById(props.token?.token, data._id, newData)
        if (res.errno) {
            alert(res.message ? JSON.stringify(res.message) : '更新失敗')
        } else {
            alert('更新成功')
            await fetchData()
        }
        setIsloading(false)
    }
    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] p-[16px] gap-[16px]" style={{ overflowY: 'scroll' }}>


            {/* 頂部輪播圖片卡 (recommendations) */}
            <div className='font-bold flex flex-row items-center gap-[24px]'>
                1. 頂部輪播圖片卡
                <button onClick={() => {
                    const newData = [...data?.recommendations]
                    newData.push({ type: null, image: null, redirect: null })
                    setData({ ...data, recommendations: newData })
                }
                } className='ml-[8px] px-[8px] py-[4px] bg-[white] text-[black] rounded-[7px] text-[12px] cursor-pointer'>+ 新增圖片卡</button>
            </div>

            <div className="w-full flex flex-col gap-[16px] items-start">
                <div className="w-full flex flex-row gap-[16px] items-start justify-start" style={{ minWidth: 500, overflowX: 'scroll' }}>
                    {data?.recommendations?.map((item, index) =>
                        <div key={index} className="w-[500px] min-w-[500px] flex flex-col items-start justify-start bg-[white] gap-[8px] rounded-[7px] p-[8px] relative">

                            <div onClick={() => {
                                const newData = [...data?.recommendations]
                                newData.splice(index, 1)
                                setData({ ...data, recommendations: newData })
                            }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>

                            <div className="text-left font-bold w-full flex flex-row">
                                圖片卡 {Number(index) + 1}
                                {/*move to front*/}
                                <div onClick={() => {
                                    const newData = [...data?.recommendations]
                                    if (index > 0) {
                                        const d = newData.splice(index, 1)[0]
                                        newData.unshift(d)
                                        setData({ ...data, recommendations: newData })
                                    }
                                }} className='cursor-pointer ml-[8px]'>⇤</div>
                                {/*move left*/}
                                <div onClick={() => {
                                    const newData = [...data?.recommendations]
                                    if (index > 0) {
                                        const temp = newData[index - 1]
                                        newData[index - 1] = newData[index]
                                        newData[index] = temp
                                        setData({ ...data, recommendations: newData })
                                    }
                                }} className='cursor-pointer ml-[8px]'>
                                    ←
                                </div>
                                {/*move right*/}
                                <div onClick={() => {
                                    const newData = [...data?.recommendations]
                                    if (index < newData.length - 1) {
                                        const temp = newData[index + 1]
                                        newData[index + 1] = newData[index]
                                        newData[index] = temp
                                        setData({ ...data, recommendations: newData })
                                    }
                                }} className='cursor-pointer ml-[8px]'>
                                    →
                                </div>
                                {/*move to end*/}
                                <div onClick={() => {
                                    const newData = [...data?.recommendations]
                                    if (index < newData.length - 1) {
                                        const d = newData.splice(index, 1)[0]
                                        newData.push(d)
                                        setData({ ...data, recommendations: newData })
                                    }
                                }} className='cursor-pointer ml-[8px]'>⇥</div>
                            </div>

                            <div className="w-full flex items-center justify-between gap-[8px]">
                                <div className="text-left font-bold">卡片類型:</div>
                                <DropDownMenu options={CARD_TYPES} value={CardTypeNameDict1[item?.type] || '請選擇'} select={
                                    (option, optionIndex) => {
                                        const newData = [...data?.recommendations]
                                        newData[index].type = CardTypeNameDict2[option] || null
                                        setData({ ...data, recommendations: newData })
                                    }
                                } />
                            </div>
                            <div className="text-left font-bold w-full">圖片(推薦比例 400:250):</div>
                            {item?.image
                                ? <div className="w-full relative flex flex-col">
                                    <img src={item?.image} alt="" className="w-full border-[1px] border-[#000] bg-[#ccc]" style={{ objectFit: 'cover', height: undefined, aspectRatio: 398 / 264 }} />
                                    <div onClick={() => {
                                        const newData = [...data?.recommendations]
                                        newData[index].image = null
                                        setData({ ...data, recommendations: newData })
                                    }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                        <RemoveSvg />
                                    </div>
                                </div>
                                : <div className="flex flex-col w-full">
                                    <div className='w-full flex flex-col max-w-[500px] min-w-[300px] gap-[8px] mt-[8px]'>
                                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                            <FileDropzone onDropFile={onDropImageFileForArray(item, index, 'recommendations', 'image', 'homepage_content', `recommendations_${Date.now()}`)} data={item} />
                                        </div>
                                    </div>
                                </div>
                            }

                            {['card2'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                <div className="text-left font-bold">標題:</div>
                                <input value={item?.title || ''} onChange={(e) => {
                                    const newData = [...data?.recommendations]
                                    newData[index].title = e.target.value
                                    setData({ ...data, recommendations: newData })
                                }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                            </div>}
                            {['card2'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                <div className="text-left font-bold">標籤:</div>
                                <input value={item?.data?.tag || ''} onChange={(e) => {
                                    const newRecommendations = [...data?.recommendations]
                                    newRecommendations[index].data = { ...(newRecommendations[index].data || {}), tag: e.target.value }
                                    setData({ ...data, recommendations: newRecommendations })
                                }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                            </div>}
                            {['card2'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                <div className="text-left font-bold">描述:</div>
                                <input value={item?.data?.description || ''} onChange={(e) => {
                                    const newRecommendations = [...data?.recommendations]
                                    newRecommendations[index].data = { ...(newRecommendations[index].data || {}), description: e.target.value }
                                    setData({ ...data, recommendations: newRecommendations })
                                }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                            </div>}
                            {['card2'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                <div className="text-left font-bold">按鈕:</div>
                                <input value={item?.data?.button || ''} onChange={(e) => {
                                    const newRecommendations = [...data?.recommendations]
                                    newRecommendations[index].data = { ...(newRecommendations[index].data || {}), button: e.target.value }
                                    setData({ ...data, recommendations: newRecommendations })
                                }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                            </div>}


                            <div className='flex flex-row items-center w-full gap-[8px]'>
                                <div className='font-[700]'>點擊重新定向到其他頁面?</div>
                                <div className='flex flex-row flex-1'>
                                    <DropDownMenu
                                        select={(option, optionIndex) => {
                                            const newRecommendations = [...data?.recommendations]
                                            newRecommendations[index].redirect = option === '是' ? { type: null, path: '', params: {} } : null
                                            setData({ ...data, recommendations: newRecommendations })
                                        }}
                                        value={item?.redirect ? '是' : '否'}
                                        minWidth={250}
                                        options={['是', '否']}
                                    />
                                </div>
                            </div>
                            {item.redirect &&
                                <div className='flex flex-row items-center w-full gap-[8px]'>
                                    <div className='font-[700]'>定向類型:</div>
                                    <div className='flex flex-row flex-1'>
                                        <DropDownMenu
                                            select={(option, optionIndex) => {
                                                const newRecommendations = [...data?.recommendations]
                                                newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), type: option === '無' ? null : option }
                                                setData({ ...data, recommendations: newRecommendations })
                                            }}
                                            value={item?.redirect?.type || '--- 無 ---'}
                                            minWidth={250}
                                            options={['無', 'in-app', 'webview', 'external-web', 'alert']}
                                        />
                                    </div>
                                </div>
                            }
                            {['webview', 'external-web'].includes(item?.redirect?.type)
                                && <div className='flex flex-row items-center w-full gap-[8px]'>
                                    <div className='font-[700]'>網站網址: </div>
                                    <div className='flex flex-row flex-1'>
                                        <input value={item?.redirect?.path || ''} onChange={(e) => {
                                            const newRecommendations = [...data?.recommendations]
                                            newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), path: e.target.value }
                                            setData({ ...data, recommendations: newRecommendations })
                                        }} placeholder='網址' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                    </div>
                                </div>}
                            {['alert'].includes(item?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                                <div className='font-[700]'>彈出訊息: </div>
                                <div className='flex flex-row flex-1'>
                                    <input value={item?.redirect?.data || ''} onChange={(e) => {
                                        const newRecommendations = [...data?.recommendations]
                                        newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), data: e.target.value }
                                        setData({ ...data, recommendations: newRecommendations })
                                    }} placeholder='訊息' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                </div>
                            </div>}
                            {['in-app'].includes(item?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                                <div className='font-[700]'>應用程式內定向路徑:</div>
                                <div className='flex flex-row flex-1'>
                                    <input value={item?.redirect?.path || ''} onChange={(e) => {
                                        const newRecommendations = [...data?.recommendations]
                                        newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), path: e.target.value }
                                        setData({ ...data, recommendations: newRecommendations })
                                    }} placeholder='路徑' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                </div>
                            </div>}
                            {['in-app'].includes(item?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                                <div className='font-[700]'>應用程式內定向路徑參數:</div>
                                <div className='flex flex-row flex-1'>
                                    <input value={item?.redirect?.params?._id || ''} onChange={(e) => {
                                        const newRecommendations = [...data?.recommendations]
                                        newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), params: { _id: e.target.value } }
                                        setData({ ...data, recommendations: newRecommendations })
                                    }} placeholder='路徑參數' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                </div>
                            </div>}

                            <div className="w-full h-[100px]" />

                        </div>
                    )}
                </div>
            </div>
            {/* 頂部輪播圖片卡 (recommendations) */}

            {/*advertisement_card_1*/}
            {/* <div className='font-bold flex flex-col items-center gap-[24px] mt-[24px]'>
                2. 廣告卡片
            </div>
            <div className="w-full bg-[white] flex flex-col items-start justify-start gap-[8px] p-[8px] rounded-[7px] max-w-[500px]">
                <div className="w-full flex items-center justify-between gap-[8px]">
                    <div className="text-left font-bold">標題:</div>
                    <input value={data?.advertisement_card_1?.title || ''} onChange={(e) => {
                        setData({ ...data, advertisement_card_1: { ...(data?.advertisement_card_1 || {}), title: e.target.value } })
                    }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                </div>
                <div className='flex-1 flex flex-row gap-[8px] w-full justify-between'>
                    <div className='font-[700]'>標籤 - 星級會員尊享: </div>
                    <DropDownMenu options={['是', '否']}
                        value={data?.advertisement_card_1?.blackVIP ? '是' : '否'}
                        select={(item, index) => {
                            setData({ ...data, advertisement_card_1: { ...(data?.advertisement_card_1 || {}), blackVIP: item === '是' } })
                        }}
                    />
                </div>
                <div className="text-left font-bold w-full">圖片(推薦比例 187:198):</div>
                {data?.advertisement_card_1?.image
                    ? <div className="w-full relative flex flex-col max-w-[200px] min-w-[200px]">
                        <img src={data?.advertisement_card_1?.image} alt="" className="w-full border-[1px] border-[#000] bg-[#ccc]" style={{ objectFit: 'cover', height: undefined, aspectRatio: 187 / 198 }} />
                        <div onClick={() => {
                            setData({ ...data, advertisement_card_1: { ...(data?.advertisement_card_1 || {}), image: null } })
                        }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                            <RemoveSvg />
                        </div>
                    </div>
                    : <div className="flex flex-col w-full">
                        <div className='w-full flex flex-col max-w-[500px] min-w-[300px] gap-[8px] mt-[8px]'>
                            <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                <FileDropzone onDropFile={onDropImageFile('advertisement_card_1', 'image', 'homepage_content', `adv_card_1}`)} data={data?.advertisement_card_1} />
                            </div>
                        </div>
                    </div>
                }
                <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>點擊重新定向到其他頁面?</div>
                    <div className='flex flex-row flex-1'>
                        <DropDownMenu
                            select={(option, optionIndex) => {
                                setData({
                                    ...data,
                                    advertisement_card_1: { ...(data?.advertisement_card_1 || {}), redirect: option === '是' ? { type: null, path: '', params: {} } : null }
                                })
                            }}
                            value={data?.advertisement_card_1?.redirect ? '是' : '否'}
                            minWidth={250}
                            options={['是', '否']}
                        />
                    </div>
                </div>
                {data?.advertisement_card_1?.redirect &&
                    <div className='flex flex-row items-center w-full gap-[8px]'>
                        <div className='font-[700]'>定向類型:</div>
                        <div className='flex flex-row flex-1'>
                            <DropDownMenu
                                select={(option, optionIndex) => {
                                    setData({
                                        ...data,
                                        advertisement_card_1: { ...(data?.advertisement_card_1 || {}), redirect: { ...(data?.advertisement_card_1?.redirect || {}), type: option === '無' ? null : option } }
                                    })
                                }}
                                value={data?.advertisement_card_1?.redirect?.type || '--- 無 ---'}
                                minWidth={250}
                                options={['無', 'in-app', 'webview', 'external-web', 'alert']}
                            />
                        </div>
                    </div>
                }
                {['webview', 'external-web'].includes(data?.advertisement_card_1?.redirect?.type)
                    && <div className='flex flex-row items-center w-full gap-[8px]'>
                        <div className='font-[700]'>網站網址: </div>
                        <div className='flex flex-row flex-1'>
                            <input value={data?.advertisement_card_1?.redirect?.path || ''} onChange={(e) => {
                                setData({
                                    ...data, advertisement_card_1: {
                                        ...(data?.advertisement_card_1 || {}), redirect: { ...(data?.advertisement_card_1?.redirect || {}), path: e.target.value }
                                    }
                                })
                            }} placeholder='網址' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                        </div>
                    </div>}
                {['alert'].includes(data?.advertisement_card_1?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>彈出訊息: </div>
                    <div className='flex flex-row flex-1'>
                        <input value={data?.advertisement_card_1?.redirect?.data || ''} onChange={(e) => {
                            setData({
                                ...data, advertisement_card_1: {
                                    ...(data?.advertisement_card_1 || {}), redirect: { ...(data?.advertisement_card_1?.redirect || {}), data: e.target.value }
                                }
                            })
                        }} placeholder='訊息' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                    </div>
                </div>}
                {['in-app'].includes(data?.advertisement_card_1?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>應用程式內定向路徑:</div>
                    <div className='flex flex-row flex-1'>
                        <input value={data?.advertisement_card_1?.redirect?.path || ''} onChange={(e) => {
                            setData({
                                ...data, advertisement_card_1: {
                                    ...(data?.advertisement_card_1 || {}), redirect: { ...(data?.advertisement_card_1?.redirect || {}), path: e.target.value }
                                }
                            })
                        }} placeholder='路徑' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                    </div>
                </div>}
                {['in-app'].includes(data?.advertisement_card_1?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>應用程式內定向路徑參數:</div>
                    <div className='flex flex-row flex-1'>
                        <input value={data?.advertisement_card_1?.redirect?.params?._id || ''} onChange={(e) => {
                            setData({
                                ...data, advertisement_card_1: {
                                    ...(data?.advertisement_card_1 || {}), redirect: { ...(data?.advertisement_card_1?.redirect || {}), params: { _id: e.target.value } }
                                }
                            })
                        }} placeholder='路徑參數' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                    </div>
                </div>}

                <div className="w-full h-[100px]" />
            </div> */}
            {/*advertisement_card_1*/}

            {/*button_1*/}
            <div className='font-bold flex flex-col items-center gap-[24px] mt-[24px]'>
                2. 按鈕 - 加入星級會員
            </div>
            <div className="w-full bg-[white] flex flex-col items-start justify-start gap-[8px] p-[8px] rounded-[7px] max-w-[500px]">
                <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>點擊重新定向到其他頁面?</div>
                    <div className='flex flex-row flex-1'>
                        <DropDownMenu
                            select={(option, optionIndex) => {
                                setData({ ...data, button_1: { ...(data?.button_1 || {}), redirect: option === '是' ? { type: null, path: '', params: {} } : null } })
                            }}
                            value={data?.button_1?.redirect ? '是' : '否'}
                            minWidth={250}
                            options={['是', '否']}
                        />
                    </div>
                </div>
                {data?.button_1?.redirect &&
                    <div className='flex flex-row items-center w-full gap-[8px]'>
                        <div className='font-[700]'>定向類型:</div>
                        <div className='flex flex-row flex-1'>
                            <DropDownMenu
                                select={(option, optionIndex) => {
                                    setData({ ...data, button_1: { ...(data?.button_1 || {}), redirect: { ...(data?.button_1?.redirect || {}), type: option === '無' ? null : option } } })
                                }}
                                value={data?.button_1?.redirect?.type || '--- 無 ---'}
                                minWidth={250}
                                options={['無', 'in-app', 'webview', 'external-web', 'alert']}
                            />
                        </div>
                    </div>
                }
                {['webview', 'external-web'].includes(data?.button_1?.redirect?.type)
                    && <div className='flex flex-row items-center w-full gap-[8px]'>
                        <div className='font-[700]'>網站網址: </div>
                        <div className='flex flex-row flex-1'>
                            <input value={data?.button_1?.redirect?.path || ''} onChange={(e) => {
                                setData({
                                    ...data, advertisement_card_1: {
                                        ...(data?.button_1 || {}), redirect: { ...(data?.button_1?.redirect || {}), path: e.target.value }
                                    }
                                })
                            }} placeholder='網址' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                        </div>
                    </div>}
                {['alert'].includes(data?.button_1?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>彈出訊息: </div>
                    <div className='flex flex-row flex-1'>
                        <input value={data?.button_1?.redirect?.data || ''} onChange={(e) => {
                            setData({
                                ...data, advertisement_card_1: {
                                    ...(data?.button_1 || {}), redirect: { ...(data?.button_1?.redirect || {}), data: e.target.value }
                                }
                            })
                        }} placeholder='訊息' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                    </div>
                </div>}
                {['in-app'].includes(data?.button_1?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>應用程式內定向路徑:</div>
                    <div className='flex flex-row flex-1'>
                        <input value={data?.button_1?.redirect?.path || ''} onChange={(e) => {
                            setData({
                                ...data, advertisement_card_1: {
                                    ...(data?.button_1 || {}), redirect: { ...(data?.button_1?.redirect || {}), path: e.target.value }
                                }
                            })
                        }} placeholder='路徑' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                    </div>
                </div>}
                {['in-app'].includes(data?.button_1?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                    <div className='font-[700]'>應用程式內定向路徑參數:</div>
                    <div className='flex flex-row flex-1'>
                        <input value={data?.button_1?.redirect?.params?._id || ''} onChange={(e) => {
                            setData({
                                ...data, button_1: {
                                    ...(data?.button_1 || {}), redirect: { ...(data?.button_1?.redirect || {}), params: { _id: e.target.value } }
                                }
                            })
                        }} placeholder='路徑參數' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                    </div>
                </div>}

                <div className="w-full h-[100px]" />
            </div>
            {/*button_1*/}



            {/* 為您推薦 (contents_recommnedations) */}
            {[
                {title:'3. 為您推薦',contentField:'contents_recommnedations'},
                {title:'4. 專題',contentField:'contents_projects'},
                {title:'5. 活動',contentField:'contents_events'},
                {title:'6. 服務',contentField:'contents_services'},
                {title:'7. 推廣',contentField:'contents_promotions'},
            ]?.map((section, sectionIndex) => 
                <div className="flex flex-col w-full items-start justify-start gap-[16px] mt-[24px]" key={sectionIndex}>
                    <div className='font-bold flex flex-row items-center gap-[24px]'>
                        {section.title}
                        <button onClick={() => {
                                const newData = [...data?.[section?.contentField]]
                                newData.push({ type: null, image: null, redirect: null , data:[], title:'',subtitle:'',description:'',location:''  })
                                setData({ ...data, [section?.contentField]: newData })
                            }} 
                            className='ml-[8px] px-[8px] py-[4px] bg-[white] text-[black] rounded-[7px] text-[12px] cursor-pointer'
                        >+ 新增內容卡</button>
                    </div>

                    <div className="w-full flex flex-col gap-[16px] items-start">
                        <div className="w-full flex flex-row gap-[16px] items-start justify-start" style={{ minWidth: 500, overflowX: 'scroll' }}>
                            {data?.[section?.contentField]?.map((item, index) =>
                                <div key={index} className="w-[500px] min-w-[500px] flex flex-col items-start justify-start bg-[white] gap-[8px] rounded-[7px] p-[8px] relative">

                                    <div onClick={() => {
                                        const newData = [...data?.[section?.contentField]]
                                        newData.splice(index, 1)
                                        setData({ ...data, [section?.contentField]: newData })
                                    }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                        <RemoveSvg />
                                    </div>

                                    <div className="text-left font-bold w-full flex flex-row">
                                        內容卡 {Number(index) + 1}
                                        {/*move to front*/}
                                        <div onClick={() => {
                                            const newData = [...data?.[section?.contentField]]
                                            if (index > 0) {
                                                const d = newData.splice(index, 1)[0]
                                                newData.unshift(d)
                                                setData({ ...data, [section?.contentField]: newData })
                                            }
                                        }} className='cursor-pointer ml-[8px]'>⇤</div>
                                        {/*move left*/}
                                        <div onClick={() => {
                                            const newData = [...data?.[section?.contentField]]
                                            if (index > 0) {
                                                const temp = newData[index - 1]
                                                newData[index - 1] = newData[index]
                                                newData[index] = temp
                                                setData({ ...data, [section?.contentField]: newData })
                                            }
                                        }} className='cursor-pointer ml-[8px]'>←</div>
                                        {/*move right*/}
                                        <div onClick={() => {
                                            const newData = [...data?.[section?.contentField]]
                                            if (index < newData.length - 1) {
                                                const temp = newData[index + 1]
                                                newData[index + 1] = newData[index]
                                                newData[index] = temp
                                                setData({ ...data, [section?.contentField]: newData })
                                            }
                                        }} className='cursor-pointer ml-[8px]'>→</div>
                                        {/*move to end*/}
                                        <div onClick={() => {
                                            const newData = [...data?.[section?.contentField]]
                                            if (index < newData.length - 1) {
                                                const d = newData.splice(index, 1)[0]
                                                newData.push(d)
                                                setData({ ...data, [section?.contentField]: newData })
                                            }
                                        }} className='cursor-pointer ml-[8px]'>⇥</div>

                                    </div>

                                    <div className="w-full flex items-center justify-between gap-[8px]">
                                        <div className="text-left font-bold">卡片類型:</div>
                                        <DropDownMenu options={CONTENT_CARD_TYPES} value={ContentCardTypeNameDict1[item?.type] || '請選擇'} select={
                                            (option, optionIndex) => {
                                                const newData = [...data?.[section?.contentField]]
                                                newData[index].type = ContentCardTypeNameDict2[option] || null
                                                setData({ ...data, [section?.contentField]: newData })
                                            }
                                        } />
                                    </div>
                                    {item.type === 'card-01'&&<div className='flex-1 flex flex-row gap-[8px] w-full justify-between'>
                                        <div className='font-[700]'>標籤 - 星級會員禮遇: </div>
                                        <DropDownMenu options={['是', '否']}
                                            value={item?.isStarPrivilege ? '是' : '否'}
                                            select={(option, optionIndex) => {
                                                const newData = [...data?.[section?.contentField]]
                                                newData[index].isStarPrivilege = option === '是'
                                                setData({ ...data, [section?.contentField]: newData })
                                            }}
                                        />
                                    </div>}
                                    {item.type === 'card-01'&&<div className='flex-1 flex flex-row gap-[8px] w-full justify-between'>
                                        <div className='font-[700]'>標籤 - 尊享會員禮遇: </div>
                                        <DropDownMenu options={['是', '否']}
                                            value={item?.isPremiumPrivilege ? '是' : '否'}
                                            select={(option, optionIndex) => {
                                                const newData = [...data?.[section?.contentField]]
                                                newData[index].isPremiumPrivilege = option === '是'
                                                setData({ ...data, [section?.contentField]: newData })
                                            }}
                                        />
                                    </div>}
                                    {(!['card-04'].includes(item.type))&&<div className="text-left font-bold w-full">圖片 ({ContentImageSizesDict[item.type]?.width+'px*'+ContentImageSizesDict[item.type]?.height+'px'}):</div>}
                                    {item.type === 'card-04'?<div/>:
                                    (item?.image)
                                        ? <div className="w-full relative flex flex-col">
                                            <img src={item?.image} alt="" className="w-full border-[1px] border-[#000] bg-[#ccc]" style={{ objectFit: 'cover', height: undefined, aspectRatio: ContentImageSizesDict[item.type]?.width / ContentImageSizesDict[item.type]?.height }} />
                                            <div onClick={() => {
                                                const newData = [...data?.[section?.contentField]]
                                                newData[index].image = null
                                                setData({ ...data, [section?.contentField]: newData })
                                            }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                                <RemoveSvg />
                                            </div>
                                        </div>
                                        : <div className="flex flex-col w-full">
                                            <div className='w-full flex flex-col max-w-[500px] min-w-[300px] gap-[8px] mt-[8px]'>
                                                <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                                    <FileDropzone onDropFile={onDropImageFileForArray(item, index, section?.contentField, 'image', section?.contentField, `${Date.now()}`)} data={item} />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {['card-04'].includes(item.type) && <div className="w-full flex flex-col items-center justify-between gap-[8px]">
                                        {item?.data?.map((dataItem, dataIndex) => 
                                            <div key={dataIndex} className="w-full flex flex-col items-center justify-center gap-[8px] relative">
                                                {(dataItem?.image)
                                                    ? <div className="w-full relative flex flex-col">
                                                        <img src={dataItem?.image} alt="" className="w-full border-[1px] border-[#000] bg-[#ccc]" style={{ objectFit: 'cover', height: undefined, aspectRatio: 805 / 237 }} />
                                                    </div>
                                                    : <div className="flex flex-col w-full">
                                                        <div> 圖片(推薦比例 805:237):</div>
                                                        <div className='w-full flex flex-col max-w-[500px] min-w-[300px] gap-[8px] mt-[8px]'>
                                                            <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                                                <FileDropzone onDropFile={onDropImageFileForArrayCard04(item, index,dataItem,dataIndex, section?.contentField, 'image', section?.contentField, `${Date.now()}`)} data={item} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <div onClick={() => {
                                                    const newData = [...data?.[section?.contentField]]
                                                    newData[index].data.splice(dataIndex, 1)
                                                    setData({ ...data, [section?.contentField]: newData }) 
                                                }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                                    <RemoveSvg />
                                                </div>

                                                <div className='flex flex-row w-full gap-[16px]'>
                                                    <div className='font-[700]'>點擊影像重新定向到其他頁面?</div>
                                                    <div className='flex flex-row'>
                                                        <DropDownMenu
                                                            select={(option, optionIndex) => {
                                                                const newData = [...data?.[section?.contentField]]
                                                                newData[index].data[dataIndex].enableRedirect = option === '是'
                                                                if(!newData[index].data[dataIndex].enableRedirect){
                                                                    newData[index].data[dataIndex].type = null
                                                                    newData[index].data[dataIndex].path = ''
                                                                    newData[index].data[dataIndex].params = {}
                                                                }
                                                                setData({ ...data, [section?.contentField]: newData })
                                                            }}
                                                            value={data?.[section?.contentField][index].data?.[dataIndex]?.enableRedirect ? '是' : '否'}
                                                            minWidth={100}
                                                            options={['是', '否']}
                                                        />
                                                    </div>
                                                </div>
                                                {(data?.[section?.contentField][index].data?.[dataIndex]?.enableRedirect) &&
                                                    <div className='flex flex-row w-full gap-[16px]'>
                                                        <div className='font-[700]'>定向類型</div>
                                                        <div className='flex flex-row'>
                                                            <DropDownMenu
                                                                select={(option, optionIndex) => {
                                                                    const newData = [...data?.[section?.contentField]]
                                                                    newData[index].data[dataIndex].type = option === '無' ? null : option
                                                                    setData({ ...data, [section?.contentField]: newData })
                                                                }}
                                                                value={data?.[section?.contentField][index].data?.[dataIndex]?.type || '--- 無 ---'}
                                                                minWidth={100}
                                                                options={['無', 'in-app', 'webview', 'external-web', 'alert']}
                                                            />
                                                        </div>
                                                    </div>
                                                }
            
                                                {['webview', 'external-web'].includes(data?.[section?.contentField][index].data?.[dataIndex]?.type)
                                                    && <div className='flex flex-row w-full gap-[16px]'>
                                                        <div className='font-[700]'>網站網址</div>
                                                        <div className='flex flex-row flex-1'>
                                                            <input value={data?.[section?.contentField][index].data[dataIndex]?.path || ''} onChange={(e) => {
                                                                const newData = [...data?.[section?.contentField]]
                                                                newData[index].data[dataIndex].path = e.target.value
                                                                setData({ ...data, [section?.contentField]: newData })
                                                            }} placeholder='網址' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                                        </div>
                                                    </div>}
                                                {['alert'].includes(data?.[section?.contentField][index].data?.[dataIndex]?.type) && <div className='flex flex-row w-full gap-[16px]'>
                                                    <div className='font-[700]'>彈出訊息</div>
                                                    <div className='flex flex-row flex-1'>
                                                        <input value={data?.[section?.contentField][index].data[dataIndex]?.data || ''} onChange={(e) => {
                                                                const newData = [...data?.[section?.contentField]]
                                                                newData[index].data[dataIndex].data = e.target.value
                                                                setData({ ...data, [section?.contentField]: newData })
                                                        }} placeholder='訊息' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                                    </div>
                                                </div>}
                                                { ['in-app'].includes(data?.[section?.contentField][index].data?.[dataIndex]?.type) && <div className='flex flex-row w-full gap-[16px]'>
                                                    <div className='font-[700]'>應用程式內定向路徑</div>
                                                    <div className='flex flex-row flex-1'>
                                                        <input value={data?.[section?.contentField][index].data[dataIndex].path || ''} onChange={(e) => {
                                                            const newData = [...data?.[section?.contentField]]
                                                            newData[index].data[dataIndex].path = e.target.value
                                                            setData({ ...data, [section?.contentField]: newData })
                                                        }} placeholder='路徑' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                                    </div>
                                                </div>}
                                                {['in-app'].includes(data?.[section?.contentField][index].data?.[dataIndex]?.type) && <div className='flex flex-row w-full gap-[16px]'>
                                                    <div className='font-[700]'>應用程式內定向路徑參數</div>
                                                    <div className='flex flex-row flex-1'>
                                                        <input value={data?.[section?.contentField][index].data[dataIndex]?.params?._id || ''} onChange={(e) => {
                                                             const newData = [...data?.[section?.contentField]]
                                                             newData[index].data[dataIndex].params = { _id: e.target.value }
                                                             setData({ ...data, [section?.contentField]: newData })
                                                        }} placeholder='路徑參數' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                                    </div>
                                                </div>}
                                            </div>
                                        )}
                                        <button onClick={() => {
                                            const newData = [...data?.[section?.contentField]]
                                            if (!newData[index].data) {
                                                newData[index].data = []
                                            }
                                            newData[index].data.push({ image: null, path: '', params: {},type: null })
                                            setData({ ...data, [section?.contentField]: newData })
                                        }} className='ml-[8px] px-[8px] py-[4px] bg-[white] text-[black] rounded-[7px] text-[12px] cursor-pointer'>+ 新增內容卡</button>
                                    </div>}

                                    {['card-03'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                        <div className="text-left font-bold">標題:</div>
                                        <input value={item?.title || ''} onChange={(e) => {
                                            const newData = [...data?.[section?.contentField]]
                                            newData[index].title = e.target.value
                                            setData({ ...data, [section?.contentField]: newData })
                                        }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                                    </div>}
                                    {['card-03'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                        <div className="text-left font-bold">副標題:</div>
                                        <input value={item?.subtitle || ''} onChange={(e) => {
                                            const newData = [...data?.[section?.contentField]]
                                            newData[index].subtitle = e.target.value
                                            setData({ ...data, [section?.contentField]: newData })
                                        }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                                    </div>}
                                    {['card-01'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                        <div className="text-left font-bold">標題:</div>
                                        <textarea value={item?.description || ''} onChange={(e) => {
                                            const newRecommendations = [...data?.[section?.contentField]]
                                            newRecommendations[index].description = e.target.value
                                            setData({ ...data, [section?.contentField]: newRecommendations })
                                        }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                                    </div>}
                                    {['card-01'].includes(item.type) && <div className="w-full flex items-center justify-between gap-[8px]">
                                        <div className="text-left font-bold">地點(可選填):</div>
                                        <textarea value={item?.location || ''} onChange={(e) => {
                                            const newRecommendations = [...data?.[section?.contentField]]
                                            newRecommendations[index].location = e.target.value
                                            setData({ ...data, [section?.contentField]: newRecommendations })
                                        }} className="flex-1 border-[#000] border-[1px] p-[2px] rounded-[4px]" />
                                    </div>}


                                    {['card-04'].includes(item.type) || <div className='flex flex-row items-center w-full gap-[8px]'>
                                        <div className='font-[700]'>點擊重新定向到其他頁面?</div>
                                        <div className='flex flex-row flex-1'>
                                            <DropDownMenu
                                                select={(option, optionIndex) => {
                                                    const newRecommendations = [...data?.[section?.contentField]]
                                                    newRecommendations[index].redirect = option === '是' ? { type: null, path: '', params: {} } : null
                                                    setData({ ...data, [section?.contentField]: newRecommendations })
                                                }}
                                                value={item?.redirect ? '是' : '否'}
                                                minWidth={250}
                                                options={['是', '否']}
                                            />
                                        </div>
                                    </div>}
                                    {(!['card-04'].includes(item.type))&&item.redirect &&
                                        <div className='flex flex-row items-center w-full gap-[8px]'>
                                            <div className='font-[700]'>定向類型:</div>
                                            <div className='flex flex-row flex-1'>
                                                <DropDownMenu
                                                    select={(option, optionIndex) => {
                                                        const newRecommendations = [...data?.[section?.contentField]]
                                                        newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), type: option === '無' ? null : option }
                                                        setData({ ...data, [section?.contentField]: newRecommendations })
                                                    }}
                                                    value={item?.redirect?.type || '--- 無 ---'}
                                                    minWidth={250}
                                                    options={['無', 'in-app', 'webview', 'external-web', 'alert']}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {(!['card-04'].includes(item.type))&&['webview', 'external-web'].includes(item?.redirect?.type)
                                        && <div className='flex flex-row items-center w-full gap-[8px]'>
                                            <div className='font-[700]'>網站網址: </div>
                                            <div className='flex flex-row flex-1'>
                                                <input value={item?.redirect?.path || ''} onChange={(e) => {
                                                    const newRecommendations = [...data?.[section?.contentField]]
                                                    newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), path: e.target.value }
                                                    setData({ ...data, [section?.contentField]: newRecommendations })
                                                }} placeholder='網址' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                            </div>
                                        </div>}
                                    {(!['card-04'].includes(item.type))&&['alert'].includes(item?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                                        <div className='font-[700]'>彈出訊息: </div>
                                        <div className='flex flex-row flex-1'>
                                            <input value={item?.redirect?.data || ''} onChange={(e) => {
                                                const newRecommendations = [...data?.[section?.contentField]]
                                                newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), data: e.target.value }
                                                setData({ ...data, [section?.contentField]: newRecommendations })
                                            }} placeholder='訊息' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                        </div>
                                    </div>}
                                    {(!['card-04'].includes(item.type))&&['in-app'].includes(item?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                                        <div className='font-[700]'>應用程式內定向路徑:</div>
                                        <div className='flex flex-row flex-1'>
                                            <input value={item?.redirect?.path || ''} onChange={(e) => {
                                                const newRecommendations = [...data?.[section?.contentField]]
                                                newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), path: e.target.value }
                                                setData({ ...data, [section?.contentField]: newRecommendations })
                                            }} placeholder='路徑' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                        </div>
                                    </div>}
                                    {(!['card-04'].includes(item.type))&&['in-app'].includes(item?.redirect?.type) && <div className='flex flex-row items-center w-full gap-[8px]'>
                                        <div className='font-[700]'>應用程式內定向路徑參數:</div>
                                        <div className='flex flex-row flex-1'>
                                            <input value={item?.redirect?.params?._id || ''} onChange={(e) => {
                                                const newRecommendations = [...data?.[section?.contentField]]
                                                newRecommendations[index].redirect = { ...(newRecommendations[index].redirect || {}), params: { _id: e.target.value } }
                                                setData({ ...data, [section?.contentField]: newRecommendations })
                                            }} placeholder='路徑參數' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full border-[1px] border-[black]' />
                                        </div>
                                    </div>}

                                    <div className="w-full h-[100px]" />

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            
             {/* 為您推薦 (contents_recommnedations) */}








            <div className="flex flex-row items-center justify-start w-full gap-[16px] mt-[24px]">
                <div onClick={handleSave} className="cursor-pointer hover:opacity-80">
                    <SaveButton/>
                </div>
                <div onClick={refresh} className="cursor-pointer hover:opacity-80">
                    <RefreshButton/>
                </div>
            </div>


            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
